import { render, staticRenderFns } from "./China.vue?vue&type=template&id=25f0ee77&scoped=true&"
import script from "./China.vue?vue&type=script&lang=js&"
export * from "./China.vue?vue&type=script&lang=js&"
import style0 from "./China.vue?vue&type=style&index=0&id=25f0ee77&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f0ee77",
  null
  
)

export default component.exports